import React, { useEffect, useState } from "react";
import { FaGrinStars } from "react-icons/fa"; // Import smiley icon
import { SetAnswersValue } from "../../../../../redux/slice/SurveySlice/AnswerSlice";
import { useDispatch } from "react-redux";
import classNames from "classnames";


export default function BooleanAnswer({ isEmoji, questionsindex, onChangeSingle, answers, options, firstEmojiUrl, secondEmojiUrl }) {
  const [selectedChoice, setSelectedChoice] = useState(-1); // Store selected choice
  const [isAnimating, setIsAnimating] = useState(false); // Track animation state
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (answers !== undefined) {
      console.log("answers:", answers);
      setIsDisabled(true);
      if (answers == 0) {
        if (isEmoji) {
          setSelectedChoice("smile");
        }
        else {
          setSelectedChoice(0);
        }
      } else if (answers == 1) {
        if (isEmoji) {
          setSelectedChoice("sad");
        }
        else {
          setSelectedChoice(1);
        }
      }
    }
  }, [answers, selectedChoice]);

  // Handle button click and trigger animation
  function handleButtonClick(choice) {
    setSelectedChoice(choice);
    setIsAnimating(true);
    let value;
    if (choice === "smile" && isEmoji) {
      value = "0";
    }
    else if (choice === "sad" && isEmoji) {
      value = "1";
    }
    else if (!isEmoji) {
      value = choice;
    }

    console.log("answer-choice", value);
    console.log("questionsindex", questionsindex);
    dispatch(SetAnswersValue({ index: questionsindex, value }));

    // Reset animation after it completes (700ms for slower pulse)
    setTimeout(() => {
      setIsAnimating(false);
      onChangeSingle();
    }, 600); // Match this duration with the animation
  };


  return (
    <div className="w-full h-full">
      <div className="p-4 rounded-2xl mt-4 flex flex-col">

        {/* Conditional rendering based on isEmoji */}
        <div
          className={`flex justify-center w-full transition-all duration-500 ease-in-out 
            ${isEmoji ? "opacity-100" : "opacity-0"}`}
        >
          {/* Emoji Mode Options */}
          {isEmoji && (
            <div className="flex justify-center space-x-4">
              <button
                className={`w-28 h-28 bg-white rounded-full shadow-lg transition-all duration-300 ease-in-out flex items-center justify-center 
                  hover:bg-yellow-400 transform hover:scale-[1.1] b
                  border-2  ${selectedChoice === "smile" ? "bg-yellow-400 text-white" : "text-yellow-500"} 
                  ${isAnimating ? "animate-pulse duration-700" : ""}
                  ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
                onClick={() => handleButtonClick("smile")}
                disabled={isDisabled}
              >
                <span className="text-7xl">
                  <img
                    src={firstEmojiUrl}
                    alt="happy Emoji"
                    className={`transition-all ${selectedChoice === "smile" ? "animate-bounce" : ""}`}
                    style={{ width: "auto", height: "4.5rem" }}
                  />
                </span>
              </button>



              <button
                className={classNames("w-28 h-28 bg-white rounded-full shadow-lg transition-all duration-300 ease-in-out flex items-center justify-center hover:bg-gray-300 transform hover:scale-[1.1] border-2", {
                  "bg-gray-300 text-white": (selectedChoice === "sad"),
                  "text-gray-500": (selectedChoice !== "sad"),
                  "animate-pulse duration-700": isAnimating,
                  "opacity-50 cursor-not-allowed": isDisabled
                })}
                onClick={() => handleButtonClick("sad")}
                disabled={isDisabled}
              >
                <span className="text-7xl">
                  <img
                    src={secondEmojiUrl}
                    alt="Sad Emoji"
                    className={`transition-all ${selectedChoice === "sad" ? "animate-bounce" : ""}`}
                    style={{ width: "auto", height: "4.5rem" }}
                  />
                </span>
              </button>

            </div>

          )}
        </div>

        <div
          className={`flex flex-wrap justify-between w-full transition-all duration-500 ease-in-out  
            ${!isEmoji ? "opacity-100" : "opacity-0"}`}
        >
          {/* Evet/Hayır Mode Options */}
          {!isEmoji && (
            <>
              <button
                className={`p-3 mr-3 rounded-lg shadow-sm transition-all duration-200 ease-in-out 
          text-center border-[1px] max-w-[110rem] ar_h:max-w-[70rem] ar_v:max-w-[45rem] w-full mb-5
          hover:bg-green-100 hover:text-green-600 transform hover:scale-[1.03] 
          ${selectedChoice === 0 ? "bg-green-500 text-white" : "bg-white text-green-500 border-green-300"} 
          ${isEmoji ? "animate-pulse duration-700" : ""} 
          ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
                onClick={() => handleButtonClick(0)}
                disabled={isDisabled}
              >
                <span className="text-base font-medium break-words">{options[0]}</span>
              </button>

              <button
                className={`p-2 rounded-lg shadow-sm transition-all duration-200 ease-in-out 
          text-center border-[1px] max-w-[110rem] ar_h:max-w-[70rem] ar_v:max-w-[45rem] w-full
          hover:bg-pink-100 transform hover:scale-[1.03] hover:text-pink-600
          ${selectedChoice === 1 ? "bg-pink-600 text-white" : "bg-white text-pink-600 border-pink-300"} 
          ${isEmoji ? "animate-pulse duration-700" : ""} 
          ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
                onClick={() => handleButtonClick(1)}
                disabled={isDisabled}
              >
                <span className="text-base font-semibold break-words">{options[1]}</span>
              </button>


            </>
          )}
        </div>
      </div>
    </div>
  );
}
